import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from '@app/services/api.service';
import { StorageEnum } from '@app/shared/enum/storage';
import { AuthSelectors } from '@app/store/auth/auth.selectors';
import { WebviewService } from '@app/services/webview.service';
import { SettingSelectors } from '@app/store/setting/setting.selectors';
import { SetAliasId } from '@app/store/setting/setting.classes';
import { Alias } from '@app/store/setting/setting.state';
import { Store } from '@ngxs/store';
import { combineLatest, Observable } from 'rxjs';

@Component({
  selector: 'app-alias-select',
  templateUrl: './alias-select.component.html',
})
export class AliasSelectComponent implements OnInit {
  aliasList: Alias[] = [];
  form!: FormGroup;
  // config from dynamodb
  config!: any;

  constructor(
    protected router: Router,
    private fb: FormBuilder,
    protected route: ActivatedRoute,
    private store: Store,
    private snackBar: MatSnackBar,
    private apiService: ApiService,
    protected webviewService: WebviewService
  ) { }

  get alias() {
    return this.store.selectSnapshot(SettingSelectors.aliasId);
  }

  ngOnInit(): void {
    this.aliasList = this.route.snapshot.data['aliasList'];
    this.aliasList.push({
      id: '',
      name: '使用しない',
    });
    this.form = this.fb.group({ alias: this.alias });
    this.configExtract();
    const findIdAlias = this.aliasList.find((f: any) => f.id == this.alias);
    if (findIdAlias) {
      findIdAlias.checked = true;
    }
  }

  get control() {
    return this.form.get('alias') as FormControl;
  }

  private configExtract() {
    try {
      const config = this.route.snapshot.data['config'];
      if (!config) return;
      // format config
      this.config = { ...config };
      const { setting } = config;
      const configExtract: { titleAlias: Alias } = JSON.parse(setting);
      const { titleAlias } = configExtract;
      if (titleAlias?.id != this.alias) {
        this.store.dispatch(new SetAliasId(titleAlias?.id || ''));
      }

    } catch { }
  }

  private applyConfig() {
    try {
      const currentTitleAlias = this.aliasList.find(x => x.id == this.control.value);
      if (!this.config || !currentTitleAlias) return;
      const { setting } = this.config;
      const titleAlias = {
        id: currentTitleAlias.id,
        name: currentTitleAlias.name
      }
      // handle no id title-alias  
      if (!setting) {
        if (titleAlias.id) {
          this.config.setting = JSON.stringify(titleAlias);
        }
      } else {
        let newSetting = JSON.parse(setting);
        if (titleAlias.id) {
          newSetting.titleAlias = titleAlias;
        } else {
          delete newSetting.titleAlias;
        }
        this.config.setting = JSON.stringify(newSetting);
      }
    } catch { }
  }

  handleConfigUpdate(): Observable<any> {
    if (this.config.companyId) {
      return this.apiService.setStfBDSetting(this.config);
    }
    const currentUnit = this.store.selectSnapshot(AuthSelectors.selectedUnit);
    const profile = this.store.selectSnapshot(AuthSelectors.profile);
    const newConfig = {
      ...this.config,
      companyId: currentUnit?.companyId.toString(),
      staffId: profile?.staffCode,
    }
    return this.apiService.initStfBDSetting(newConfig);
  }

  onSubmit(): void {
    try {
      this.applyConfig();
      combineLatest([
        this.handleConfigUpdate(),
        this.store.dispatch(new SetAliasId(this.control.value))
      ]).subscribe(() => {
        localStorage.setItem(StorageEnum.ALIASTRIGGER, this.control.value)
        this.snackBar.open('設定を保存しました');
        this.router.navigate(['', { outlets: { modal: null } }]);
      })

    } catch (error) {
    } finally {
      this.cancel();
    }
  }

  cancel() { }
}
